import React from 'react';
import { Box, Toolbar } from '@mui/material';
import { Outlet } from 'react-router-dom';
import AppAppBar from '../components/AppAppBar';

export default function AuthenticatedLayout() {
  return (
    <>
      <AppAppBar />
      <Box component="main" sx={{ flexGrow: 1, p: 3 }}>
        <Toolbar />
        <Outlet />
      </Box>
    </>
  );
}
